import React from 'react';

import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  createProcessTaskDefinition,
  CreateProcessTaskDefinitionRequest,
} from 'processes/dao/ProcessTaskDefinitionDAO';
import {withLoadingScreen} from 'util/Promises';

import {ProcessTaskDefinitionGraphQL} from '../../../graphql-fragments/processes/__generated/ProcessTaskDefinitionGraphQL';
import ProcessTaskSchemaEditor from './ProcessTaskSchemaEditor';

export default function CreateProcessTaskDefinitionEditor(props: {
  restrictedToExecutionType?: ProcessExecutionType;
  restrictedToOrganizationId?: string;
  onCreateProcessTaskDefinition: (processTaskDefinition: ProcessTaskDefinitionGraphQL) => void;
}): JSX.Element {
  return (
    <ProcessTaskSchemaEditor
      schemaId={null}
      restrictedToExecutionType={props.restrictedToExecutionType}
      restrictedToOrganizationId={props.restrictedToOrganizationId}
      isSettingsPage={false}
      createProcessTaskSchema={async (processTaskSchemaSpec) => {
        const requestData: CreateProcessTaskDefinitionRequest = {
          organizationId: processTaskSchemaSpec.organizationId,
          name: processTaskSchemaSpec.name,
          firstVersion: {
            taskSchemaSpec: processTaskSchemaSpec,
            applicationData: null,
          },
        };
        const processTaskDefinition = await withLoadingScreen(
          createProcessTaskDefinition(requestData),
          'Saving...'
        );
        props.onCreateProcessTaskDefinition(processTaskDefinition);
      }}
    />
  );
}
